import type { TextareaHTMLAttributes } from "react";

interface Props extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  mono?: boolean;
}

export function Textarea({ className = "", mono = false, ...rest }: Props) {
  return <textarea className={`control ${mono ? "mono" : ""} ${className}`.trim()} {...rest} />;
}
